import React from 'react'
import styled from 'styled-components'
import { MyTheme } from 'Components/common/Theme'
import { Col, Row } from 'antd'
import { cmToPx } from 'helpers/format'
import { menuPaperSize } from 'helpers/constanst'
import Type2 from './Barcode/type2'
import Type1 from './Barcode/type1'
import Type3 from './Barcode/type3'

type Props = {
  barcode?: string
  title?: string
  price?: number
  configData?: any
  uom?: string
}

const BarcodePDF: React.FunctionComponent<Props> = props => {
  const { barcode = '', title = '', price, configData, uom = '' } = props
  const paperType = configData?.paperType || '1'
  const paper = getPaperSpec(paperType)
  const numrows = paper?.row || 0

  const getBarcode = () => {
    switch (paperType) {
      case '1':
        return <Type1 barcode={barcode} title={title} price={price} configData={configData} uom={uom} />
      case '2':
      case '3':
      case '4':
        return <Type2 barcode={barcode} title={title} price={price} configData={configData} uom={uom} />
      default:
        return <Type1 barcode={barcode} title={title} price={price} configData={configData} uom={uom} />
    }
  }

  const barcodeRows = []
  for (let i = 0; i < numrows; i++) {
    barcodeRows.push(<Col>{getBarcode()}</Col>)
  }

  return (
    <BoxWrapper about={paperType}>
      {paper?.isCenter ? <Row justify={'center'}>{barcodeRows}</Row> : <Row justify="end">{barcodeRows}</Row>}
    </BoxWrapper>
  )
}

const getPaperSpec = (type: string) => {
  return menuPaperSize.find(item => item.value === type)?.spec
}

const getPaperSize = (props: any): string => {
  const type = props.about
  const paper = getPaperSpec(type)
  const inpx = cmToPx(paper?.paper || 0)

  return `${inpx}px`
}

const getStickerWidth = (props: any): string => {
  const type = props.about
  const paper = getPaperSpec(type)
  const inpx = cmToPx(paper?.w || 0)

  return `${inpx}px`
}

const getStickerHeight = (props: any): string => {
  const type = props.about
  const paper = getPaperSpec(type)
  const inpx = cmToPx(paper?.h || 0)

  return `${inpx}px`
}

const BoxWrapper = styled.div`
  width: 0;
  height: 0;
  overflow: hidden;
  // width: ${getPaperSize};
  // height: ${getStickerHeight};
  //background-color: red;
  font-family: ${(props: { theme: MyTheme }): string => props.theme.fontFamily.medium};
  //border: 1px solid red;

  @media print {
    width: ${getPaperSize};
    height: ${getStickerHeight};
    overflow: hidden;

    @page {
      width: ${getPaperSize};
      height: ${getStickerHeight};
    }
  }
`

export default BarcodePDF
